export default {
  setExcursionTypes(state, types) {
    state.types = types;
  },
  setExcursionRiskCategoriesOptions(state, options) {
    state.riskCategoriesOptions = options;
  },
  setExcursionConfig(state, config) {
    state.excursionConfig = config;
  }
};
